/* unplugin-vue-components disabled */import { render } from "./teacher.vue?vue&type=template&id=5e364d53&scoped=true&ts=true"
import script from "./teacher.vue?vue&type=script&lang=ts"
export * from "./teacher.vue?vue&type=script&lang=ts"

import "./teacher.vue?vue&type=style&index=0&id=5e364d53&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\智慧校园\\school-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e364d53"]])

export default __exports__